export const AIAIcon = (props) => (
  <svg
    width="25"
    height="23"
    viewBox="0 0 25 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.177 2.90792L18.8853 0L20.4979 2.72189L18.783 5.6405L24.2757 14.9865C25.7707 17.533 24.8763 20.8173 22.2845 22.2883C19.6927 23.7572 16.3479 22.8784 14.8529 20.3319L13.8345 18.5978L15.4405 15.8652L17.2619 18.9677C17.9888 20.2057 19.6339 20.6376 20.8939 19.9235C22.1539 19.2093 22.5935 17.5929 21.8667 16.3549L17.1792 8.37522L18.7874 5.6405L17.1814 2.90792H17.177ZM15.5536 5.6683L17.1749 2.90792C16.2087 1.33636 14.5308 0.423358 12.7769 0.337831H12.7442L12.6572 0.333555H12.6289H12.6071H12.507H12.4983H12.4069H12.396H12.3199L12.2937 0.335693C10.481 0.401977 8.73791 1.35133 7.76952 2.99986L0.725297 14.9865C-0.771899 17.533 0.124678 20.8173 2.71648 22.2883C5.30828 23.7572 8.65304 22.8763 10.1481 20.3319L14.4917 12.9402L14.5178 12.8953L14.9922 12.0871L17.1575 8.40302L15.5515 5.67043L13.3862 9.35664L12.9879 10.0323L12.8835 10.2076L7.73688 18.9656C7.01004 20.2036 5.36487 20.6355 4.10487 19.9214C2.84488 19.2072 2.40529 17.5907 3.13213 16.3527L10.1763 4.36615C10.5963 3.64986 11.3232 3.20512 12.1044 3.0918C12.235 3.07469 12.3677 3.064 12.5005 3.064H12.5505H12.5549C12.9836 3.07469 13.4145 3.18374 13.8084 3.40825C14.1652 3.61137 14.4568 3.8872 14.6745 4.20579L15.5493 5.66616L15.5536 5.6683Z"
      fill="url(#paint0_linear_2013_15975)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2013_15975"
        x1="10.0393"
        y1="3.42108"
        x2="20.1027"
        y2="21.5336"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F12E11" />
        <stop offset="1" stop-color="#F5AA19" />
      </linearGradient>
    </defs>
  </svg>
);
